<template>
  <section class="preorder-section-container">
    <div class="content-wrapper">
      <div class="title-wrapper">
        <div>
          <h2>előrendelés</h2>
          <div class="underline"></div>
        </div>
      </div>
      <div class="preorder-details-wrapper">
        <div class="text-block">
          <p>Jelenleg az összes <b>FOKOS</b> 21 elfogyott. Elegendő érdeklődő esetén azonban lehetséges, hogy újra gyártásba kerül.
            <br><br>
            Ha nem szeretnél lemaradni, add meg elérhetőséged, amin értesíthetünk...</p>
        </div>
        <div class="preorder-card">
          <transition name="fade">
          <div v-if='isSubmitted' class="success">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#1bc527" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            <h5>Köszönjük! Ha újraindul a fokos gyártása, azonnal értesíteni fogunk.</h5>
          </div>
          <div v-if='isError' class="success">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#ff3c11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
            <h5>Valami hiba történt, kérjük próbálkozz újra később.</h5>
          </div>
          <form v-if='!isSubmitted && !isError' @submit.prevent="handleSubmit" name="preorder" method="POST" id="preorder-form" netlify netlify-honeypot="bot-field">
            <label class="hidden">Don't fill this out if you're human: <input name="bot-field"></label>
            <input v-model='form.name' name="name" class="input-field" type="text" placeholder="név*" required>
            <input v-model='form.email' name="email" class="input-field" type="email" placeholder="email*" required>
            <input v-model='form.notes' name="notes" class="input-field" type="text" placeholder="megjegyzés">
            <input v-model='form.amount' name="amount" class="input-field" type="number" placeholder="darabszám*" min="1" max="50" required>
            <div class="submit-btn"><button type="submit" form="preorder-form" value="Submit">küldés</button></div>
          </form>
            </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PreorderSection",
  data: () => ({
    form: {
      name: '',
      email: '',
      notes: '',
      amount: null,
    },
    isSubmitted: false,
    isError: false
  }),
  methods: {
    resetForm() {
      this.form = {
        name: '',
        email: '',
        notes: '',
        amount: null,
      }
    },
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join("&");
    },
    handleSubmit() {
      fetch('/', {
        method: 'post',
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: this.encode({
          "form-name": "preorder",
          ...this.form
        }),
      })
      .then(() => {
        this.resetForm()
        this.isError = false;
        this.isSubmitted = true;
      })
      .catch((err) => {
        console.error('form submission failed: ', err)
        this.resetForm()
        this.isError = true;
        this.isSubmitted = false;
      })
    }
  },
  mounted() {
    document.addEventListener('invalid', (function () {
      return function (e) {
        e.preventDefault();
        document.getElementById("preorder-form").focus();
      };
    })(), true);
  }
}
</script>

<style scoped>
.preorder-section-container {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: linear-gradient(180deg, #FAFAFA 0%, #F2F2F2 100%);
  padding: 5% 0;
  overflow: hidden;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 1000px;
}

.title-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  padding-left: 5%;
  line-height: 1.1;
}

h2 {
  font-size: 72px;
  font-weight: 900;
  text-transform: uppercase;
}

.underline {
  background: #EFBE3E;
  height: 6px;
  width: 100%;
  border-radius: 10px;
  margin-bottom: 0.5rem;
}

.preorder-details-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 3%;
}

.text-block {
  width: 40%;
  font-size: 24px;
  height: 500px;
  padding-right: 10px;
}

.preorder-card {
  width: 500px;
  height: 455px;
  background: #FFFFFF;
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  overflow: hidden;
}

.preorder-card:hover {
  box-shadow: 4px 8px 6px rgba(0, 0, 0, 0.20);
}

.input-field {
  width: 70%;
  padding-left: 10px;
  font-size: 22px;
  border: 0;
  outline: none;
  transition: all 0.2s ease-in-out;
  border-bottom: 1px solid #BBBBBB;
}

.input-field:not(:placeholder-shown) {
  border-bottom: 1px solid #EFBE3E;
}

.input-field:not(:placeholder-shown):invalid {
  border-bottom: 1px solid crimson;
}

.input-field::placeholder {
  color: #BBBBBB;
}

.input-field::-webkit-outer-spin-button,
.input-field::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.submit-btn {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #EFBE3E;
  height: 40px;
  width: 140px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  transition: all 0.3s ease-in-out;
}

.submit-btn:hover {
  box-shadow: 3px 6px 10px rgba(0, 0, 0, 0.35);
}

form {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 5%;
}

button {
  background: transparent;
  outline: none;
  width: 100%;
  height: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 0;
  text-transform: uppercase;
  font-weight: bold;
  transition: all 0.15s ease-in-out;
}

form:invalid .submit-btn {
  background: #888888;
}

form:invalid button {
  color: white;
}

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

h5 {
  margin: 20px;
  padding: 0 50px;
  font-weight: bold;
  text-align: center;
  font-size: 18px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s ease-in-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.hidden {
  display: none;
}

@media only screen and (max-width: 1200px) {
  .preorder-card {
    width: 400px;
    height: 450px;
    margin-left: 20px;
  }

  h2 {
    margin-top: 25px;
    font-size: 48px;
    letter-spacing: 3px;
  }

  .title-wrapper {
    padding-left: 7%;
  }

  form {
    padding: 5% 0;
  }

  .content-wrapper {
    width: 900px;
  }

  .text-block {
    font-size: 22px;
  }
}

@media only screen and (max-width: 900px) {
  .title-wrapper {
    align-items: center;
    width: 100vw;
    padding-left: 0;
    margin-bottom: 30px;
  }

  .preorder-details-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 10%;
  }

  h2 {
    font-size: 48px;
  }

  .text-block {
    width: 100vw;
    height: auto;
    font-size: 20px;
    max-width: 580px;
    margin-left: 5%;
    padding: 0 40px;
  }

  .preorder-card {
    margin-top: 50px;
    width: 500px;
    height: 455px;
  }
}

@media only screen and (max-width: 700px) {
  .preorder-section-container {
    padding-bottom: 0;
  }

  .preorder-card {
    border-radius: 0;
    width: 100vw;
    box-shadow: none;
    margin-left: 0;
  }

  .preorder-card:hover {
    box-shadow: none;
  }

  .text-block {
    margin-left: 0;
    padding-left: 5%;
    font-size: 18px;
  }

}

@media only screen and (max-width: 600px) {
  h2 {
    font-size: 34px;
  }
}
</style>
